import { Box } from "@mui/material";
import { createUseStyles } from "react-jss";
import { useQuery } from "react-query";
import { theme } from "$utils/theme/bataillog";
import { Text } from "$components";
import useOrder from "$hooks/useOrder";
import { DockyardServices, ProjectServices } from "$services";
import { Loader } from "$components/Layout/Loader";
import { CacheInvalidationAction } from "$utils/cache";

type Props = {
  /**
   * If provided, used instead of suborder.reference.
   */
  customReference?: string;
  suborder: any;
};

function Title({ customReference, suborder }: Props) {
  const classes = useStyles();
  const { getSplitSuborderTypeInfo } = useOrder();

  // get one project
  const { data: project, isLoading: isProjectLoading } = useQuery(
    [CacheInvalidationAction.GET_PROJECT_BY_ID, suborder?.project],
    () => ProjectServices.getProjectById(suborder?.project),
    {
      enabled: !!suborder?.project,
      staleTime: 5 * 1000 * 60,
    }
  );

  // get one dockyard
  const { data: dockyard, isLoading: isDockyardLoading } = useQuery(
    [CacheInvalidationAction.GET_DOCKYARD_BY_ID, suborder?.dockyard],
    () => DockyardServices.getDockyardById(suborder?.dockyard),
    {
      enabled: !!suborder?.dockyard,
      staleTime: 5 * 1000 * 60,
    }
  );

  if (isDockyardLoading || isProjectLoading) {
    return <Loader />;
  }

  const { code, label, name } = getSplitSuborderTypeInfo(
    suborder.type,
    dockyard,
    project
  );

  return (
    <Box key={suborder.reference} className={classes.suborder}>
      <Text type="important" className={classes.title}>
        {customReference || suborder.reference}
      </Text>
      &nbsp;
      <Text>{name}</Text>
      &nbsp;
      <Text className={classes.lightText}>
        {code}
        {label ? ` (${label})` : ""}
      </Text>
    </Box>
  );
}
export default Title;

const useStyles = createUseStyles(() => ({
  lightText: {
    color: theme.color.gray5,
  },
  suborder: {
    alignItems: "center",
    display: "inline-flex",
    marginTop: `${theme.spacing(0)}px`,
  },
  title: {
    fontSize: "1.1rem",
    fontWeight: "600",
  },
}));
